// extracted by mini-css-extract-plugin
export var filterIncDec = "_bl-0";
export var leftBorder = "_bl-1";
export var rightBorder = "_bl-2";
export var stringInput = "_bl-3";